const decodePathSegment = (value: string) => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const parsePathSegments = (value: string) =>
  value
    .split('/')
    .map((segment) => segment.trim())
    .filter(Boolean)
    .map(decodePathSegment)
    .filter(Boolean)
